var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import FileUpload from "~/components/common/file-upload.vue";
import { Dependencies } from "~/core/decorator";
import { State } from "vuex-class";
import { Emit, Prop } from "vue-property-decorator";
import { DataImportService } from "~/services/dataimp-service/data-import.service";
import { ImportTemplateService } from "~/services/dataimp-service/import-template.service";
var ImportCaseCommon = /** @class */ (function (_super) {
    __extends(ImportCaseCommon, _super);
    function ImportCaseCommon() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.templateList = [];
        _this.importModel = {
            fileId: "",
            principalId: "",
            type: _this.importType,
            templateId: "",
        };
        _this.importRules = {
            principalId: [{ required: true, message: "请选择委托方", trigger: "blur" }],
            templateId: [{ required: true, message: "请选择导入模板", trigger: "blur" }],
        };
        _this.fileList = [];
        _this.loading = { state: false };
        return _this;
    }
    ImportCaseCommon.prototype.close = function () {
        this.reset();
    };
    ImportCaseCommon.prototype.success = function () {
        this.close();
    };
    /**
     * 表单重置
     */
    ImportCaseCommon.prototype.reset = function () {
        this.loading.state = false;
        var form = this.$refs["form"];
        var upload = this.$refs["upload_case_import"];
        form.resetFields();
        upload.reset();
    };
    ImportCaseCommon.prototype.cancel = function () {
        this.close();
    };
    /**
     * 表单提交
     */
    ImportCaseCommon.prototype.submit = function () {
        var _this = this;
        if (this.fileList.length === 0) {
            this.$message("请上传导入文件");
            return;
        }
        // 文件ID
        this.importModel.fileId = this.fileList[0].response.id;
        var form = this.$refs["form"];
        form.validate(function (valid) {
            if (!valid)
                return;
            _this.loading.state = true;
            if (_this.importType === "BILL_IMPORT") {
                _this.dataImportService.importBill(_this.importModel, _this.loading).subscribe(function (data) {
                    _this.$message.success("对账单正在导入");
                    _this.success();
                }, function (err) {
                    _this.$message.error(err.msg);
                });
            }
            else if (_this.importType === "PRE_RECORD_IMPORT") {
                _this.dataImportService.importPreRecord(_this.importModel, _this.loading).subscribe(function (data) {
                    _this.$message.success("委前调记正在导入");
                    _this.success();
                }, function (err) {
                    _this.$message.error(err.msg);
                });
            }
            else if (_this.importType === "WORK_ORDER_IMPORT") {
                _this.dataImportService.importWorkOrder(_this.importModel, _this.loading).subscribe(function (data) {
                    _this.$message.success("工单正在导入");
                    _this.success();
                }, function (err) {
                    _this.$message.error(err.msg);
                });
            }
            else if (_this.importType === "WARNING_IMPORT") {
                _this.dataImportService.importWarning(_this.importModel, _this.loading).subscribe(function (data) {
                    _this.$message.success("警告正在导入");
                    _this.success();
                }, function (err) {
                    _this.$message.error(err.msg);
                });
            }
            else if (_this.importType === "LEAVE_IMPORT") {
                _this.dataImportService.leaveImport(_this.importModel, _this.loading).subscribe(function (data) {
                    _this.$message.success("留案案件正在导入");
                    _this.success();
                }, function (err) {
                    _this.$message.error(err.msg);
                });
            }
            else if (_this.importType === "STOP_IMPORT") {
                _this.dataImportService.stopImport(_this.importModel, _this.loading).subscribe(function (data) {
                    _this.$message.success("停调案件正在导入");
                    _this.success();
                }, function (err) {
                    _this.$message.error(err.msg);
                });
            }
        });
    };
    /**
     * 委托方ID变化
     */
    ImportCaseCommon.prototype.principalIdChange = function () {
        var _this = this;
        //根据委托方ID查找委托方Obj并且获取模板名称
        var principalObj = this.principalList.find(function (v) { return v.id === _this.importModel.principalId; });
        //重置模板列表并获取选取委托方对应的模板列表
        this.templateList = [];
        this.importModel.templateId = "";
        var excelModel = {
            principalId: this.importModel.principalId,
            type: this.importType,
        };
        this.loading.state = true;
        this.importTemplateService.getTemplateByPrincipal(excelModel, this.loading).subscribe(function (data) { return (_this.templateList = data); });
    };
    __decorate([
        Dependencies(DataImportService)
    ], ImportCaseCommon.prototype, "dataImportService", void 0);
    __decorate([
        Dependencies(ImportTemplateService)
    ], ImportCaseCommon.prototype, "importTemplateService", void 0);
    __decorate([
        Prop({ required: true })
    ], ImportCaseCommon.prototype, "importType", void 0);
    __decorate([
        Emit()
    ], ImportCaseCommon.prototype, "close", null);
    __decorate([
        Emit()
    ], ImportCaseCommon.prototype, "success", null);
    __decorate([
        State
    ], ImportCaseCommon.prototype, "principalList", void 0);
    ImportCaseCommon = __decorate([
        Component({
            components: { FileUpload: FileUpload },
        })
    ], ImportCaseCommon);
    return ImportCaseCommon;
}(Vue));
export default ImportCaseCommon;
